import React, { useState } from "react";
import { VendorReportForm } from "./vendorReportForm";
import VendorReportGrid from "./vendorReportGrid";

const ListRegister = () => {
  const[lastPayload,setLastPayload]=useState(null)
  return (
    <>
      <VendorReportForm setLastPayload={setLastPayload}/>
      <VendorReportGrid lastPayload={lastPayload} />
    </>
  );
};

export default ListRegister;
